import React from 'react';
import { AlertTriangle, Loader2, UserX } from 'lucide-react';
import './StatusMessage.css';

interface StatusMessageProps {
  type: 'loading' | 'error' | 'notfound';
  message?: string;
}

const StatusMessage: React.FC<StatusMessageProps> = ({ type, message }) => {
  const renderIcon = () => {
    switch (type) {
      case 'loading':
        return <Loader2 className="icon spin" />;
      case 'error':
        return <AlertTriangle className="icon error" />;
      case 'notfound':
        return <UserX className="icon notfound" />;
      default:
        return null;
    }
  };

  const renderText = () => {
    if (message) return message;
    switch (type) {
      case 'loading':
        return 'Loading profile...';
      case 'error':
        return 'An unexpected error occurred.';
      case 'notfound':
        return 'User not found.';
      default:
        return '';
    }
  };

  return (
    <div className={`status-container ${type}`}>
      <div className="status-box">
        {renderIcon()}
        <p className="status-text">{renderText()}</p>
      </div>
    </div>
  );
};

export default StatusMessage;
